import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the FilterPartnersProductsView.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size
        let categoriesoptions = []; // Array to hold category options
        let type = ''; // Variable to hold selected category type
        let country = ''; // Variable to hold selected country

        // Check if country report is enabled
        if (devConfig.getCountryReport()) {
            country = profile.Settings.ReportCountry; // Get report country from profile
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories',
                    { country: country }, // Send country in request
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map Id to id
                                resp.data[i].value = resp.data[i].Description; // Map Description to value
                            }
                            // Add default category options
                            resp.data.unshift({
                                id: '-3',
                                Id: '',
                                value: _('Todas (VIRTUALES)'),
                                Type: 2,
                            });
                            resp.data.unshift({
                                id: '-2',
                                Id: '',
                                value: _('Todas (LIVECASINO)'),
                                Type: 1,
                            });
                            resp.data.unshift({
                                id: '-1',
                                Id: '',
                                value: _('Todas (CASINO)'),
                                Type: 0,
                            });
                            $$('Categorie').define('options', resp.data); // Define options for Categorie
                            categoriesoptions = resp.data; // Store categories options
                        },
                    },
                );
        }

        // Left section configuration
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'), // Label for provider
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}', // Send filter text
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId',
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'), // Label for sub-provider
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}', // Send filter text
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country with flag
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Check permissions for country filtering
                                ),
                            css: 'prm-filterByCountry',
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get current value
                                    if (currentValue.length > 0 && $$('Categorie').getValue().length > 0) {
                                        $$('button').enable(); // Enable button if both fields have values
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                    if (currentValue.length > 0) {
                                        country = currentValue; // Update country variable
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Categories/GetCategories',
                                                { country: country }, // Send country in request
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse response
                                                        for (var i = 0; i < resp.data.length; i++) {
                                                            resp.data[i].id = resp.data[i].Id; // Map Id to id
                                                            resp.data[i].value = resp.data[i].Description; // Map Description to value
                                                        }
                                                        // Add default category options
                                                        resp.data.unshift({
                                                            id: '-3',
                                                            Id: '',
                                                            value: _('Todas (VIRTUALES)'),
                                                            Type: 2,
                                                        });
                                                        resp.data.unshift({
                                                            id: '-2',
                                                            Id: '',
                                                            value: _('Todas (LIVECASINO)'),
                                                            Type: 1,
                                                        });
                                                        resp.data.unshift({
                                                            id: '-1',
                                                            Id: '',
                                                            value: _('Todas (CASINO)'),
                                                            Type: 0,
                                                        });
                                                        $$('Categorie').define(
                                                            'options',
                                                            resp.data, // Define options for Categorie
                                                        );
                                                        categoriesoptions = resp.data; // Store categories options
                                                    },
                                                },
                                            );
                                    }
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            id: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true, // Make it read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country with flag
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Check permissions for country filtering
                                ),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            cols: [
                                {
                                    view: 'richselect',
                                    name: 'Categorie',
                                    localId: 'categorie:combo',
                                    label: "<span class='icon-category'></span>" + _('Categorías'), // Label for categories selection
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '), // Placeholder text
                                    id: 'Categorie',
                                    options: [], // Initial empty options
                                    on: {
                                        onChange: function (value) {
                                            if (
                                                categoriesoptions.filter((item) => {
                                                    return item.id == value; // Check if selected value exists in categories
                                                }).length > 0
                                            ) {
                                                type = categoriesoptions.filter((item) => {
                                                    return item.id == value; // Get type of selected category
                                                })[0].Type;
                                            }
                                            var currentValue = this.getValue(); // Get current value
                                            if (
                                                (currentValue.length > 0 &&
                                                    $$('CountrySelect').getValue().length > 0) ||
                                                devConfig.getCountryReport()
                                            ) {
                                                $$('button').enable(); // Enable button if conditions are met
                                            } else {
                                                $$('button').disable(); // Disable button otherwise
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeDevice',
                            id: 'TypeDevice',
                            label: _('Dispositivo'), // Label for device type selection
                            labelPosition: 'top',
                            value: 2, // Default value
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>", // Phone icon
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>", // Display icon
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Right section configuration
        const left2 = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'), // Label for verification status
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'null', value: 'Todos' }, // Option for all
                                { id: 'A', value: 'Activado' }, // Option for activated
                                { id: 'I', value: 'Inactivado' }, // Option for deactivated
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'), // Label for country filter
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '', value: 'Todos' }, // Option for all
                                { id: 'A', value: 'Activado' }, // Option for activated
                                { id: 'I', value: 'Inactivado' }, // Option for deactivated
                            ],
                        },
                        {
                            view: 'text',
                            name: 'FeaturedOrder',
                            type: 'number',
                            label: "<span class='icon-reorder'></span>" + _('Orden Destacado'), // Label for featured order
                            labelPosition: 'top',
                            placeholder: _('Orden Destacado'), // Placeholder text
                            invalidMessage: _('Máximo is required'), // Invalid message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'), // Label for maximum value
                            labelPosition: 'top',
                            placeholder: _('Máximo'), // Placeholder text
                            invalidMessage: _('Máximo is required'), // Invalid message
                        },
                        {
                            view: 'text',
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'), // Label for minimum value
                            labelPosition: 'top',
                            placeholder: _('Mínimo'), // Placeholder text
                            invalidMessage: _('Mínimo is required'), // Invalid message
                        },
                        {
                            view: 'text',
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'), // Label for processing time
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'), // Placeholder text
                            invalidMessage: _(
                                'Tiempo Procesamiento is required', // Invalid message
                            ),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeDevice',
                            label: _('Dispositivo'), // Label for device type selection
                            labelPosition: 'top',
                            value: 3, // Default value
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>", // Phone icon
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>", // Display icon
                                },
                                { id: 3, value: _('Ambos') }, // Option for both
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section configuration
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 370 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        // Upper section 2 configuration
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 500 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Include left2 section
                },
            ],
        };

        // Accordion section configuration
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Include upper_section2
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section configuration
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                                $$('button').disable(); // Disable button
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            disabled: true, // Initially disabled
                            value: _('Consultar'), // Consult button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (type !== '') {
                                    filterdata.Type = type; // Set type if available
                                }
                                if (parseInt(filterdata.Categorie) < 0) {
                                    filterdata.Categorie = ''; // Clear category if negative
                                }
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('partnerProducts:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b1').collapse(); // Collapse the accordion
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section 1 configuration
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper_section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Include accordion_section1
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (devConfig.getCountryReport() && $$('Categorie').getValue().length > 0) {
                $$('button').enable(); // Enable button if conditions are met
            }
        });
    }
}

// FILE DOCUMENTED
